import $ from 'jquery';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import autoComplete from '@tarekraafat/autocomplete.js';
import motivUi from './lib/motiv-core-ui/js/motivUi.min.js';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

const fpPromise = FingerprintJS.load();

async function getDeviceFingerprint() {
    const fp = await fpPromise;
    const result = await fp.get();
    return result.visitorId;
}

$.validator.unobtrusive.options = {
    errorClass: 'motivValidationError'
};

$.ajaxSetup({ xhrFields: { withCredentials: true }, crossDomain: true });

var parseLocalizedFloat = function (value) {
    if (value == '' || value == undefined) {
        return undefined;
    }

    return parseFloat(motivUi.string.removeGroupSeparators(value ?? '0', true));
}

$.validator.addMethod('minloanamount', function (value, _element, params) {
    var price = $(`#MotivCalculator_CalculatorDetails_${params.price}`);
    var priceVal = parseLocalizedFloat(price.val());
    if (priceVal == undefined || !price.valid()) {
        return true;
    }
    return priceVal - parseFloat(value) >= parseLocalizedFloat(params.minimum);
}, function (params, element) {
    var price = parseLocalizedFloat($(`#MotivCalculator_CalculatorDetails_${params.price}`).val());
    var deposit = parseLocalizedFloat($(element).val());
    var maxDeposit = price - parseLocalizedFloat(params.minimum);
    return $.validator.format($(element).attr('data-val-minloanamount'), motivUi.string.addGroupSeparator(maxDeposit));
});

$.validator.unobtrusive.adapters.add('minloanamount', ['price', 'minimum'], function (options) {
    options.rules['minloanamount'] = options.params;
    $(`#MotivCalculator_${options.params.price}`).on('keyup change input', function () {
        $(options.element).valid(['minloanamount']);
    });
});

$.validator.addMethod('maxdepositpercentage', function (value, _element, params) {
    var price = $(`#MotivCalculator_CalculatorDetails_${params.price}`);
    var priceVal = parseLocalizedFloat(price.val());
    if (priceVal == undefined || priceVal == 0 || !price.valid()) {
        return true;
    }
    return parseFloat(value) / priceVal * 100  <= parseLocalizedFloat(params.maximum);
}, function (params, element) {
    var price = parseLocalizedFloat($(`#MotivCalculator_CalculatorDetails_${params.price}`).val());
    var maxDeposit = price * parseLocalizedFloat(params.maximum) / 100;
    return $.validator.format($(element).attr('data-val-maxdepositpercentage'), motivUi.string.addGroupSeparator(maxDeposit));
});

$.validator.unobtrusive.adapters.add('maxdepositpercentage', ['price', 'maximum'], function (options) {
    options.rules['maxdepositpercentage'] = options.params;
    $(`#MotivCalculator_${options.params.price}`).on('keyup change input', function () {
        $(options.element).valid(['maxdepositpercentage']);
    });
});

var calculatorScript = $('[data-motiv-calculator-script]')
var calculatorBaseUrl = calculatorScript.attr('src').replace('/js/calculator.min.js', '');
var dealership = calculatorScript.attr('data-val-dealership');
var vrm = calculatorScript.attr('data-val-vrm');
var currentMileage = calculatorScript.attr('data-val-current-mileage');
var price = calculatorScript.attr('data-val-price');
var tenant = calculatorScript.attr('data-tenant');
var carKnown = dealership && vrm && currentMileage && price;
var calculatorEndpoint = `${calculatorBaseUrl}/${tenant}/${(carKnown ? 'carknown' : 'carunknown')}`;
loadStylesheet(tenant);

window.addEventListener('error', function (e) {
    if (e.filename.includes(calculatorBaseUrl)) {
        var error = JSON.stringify({
            sessionId: $('#MotivCalculator_CalculatorDetails_SessionId').val() || null,
            message: e.message,
            stackTrace: `at ${e.filename}:${e.lineno}:${e.colno}`
        });

        $.ajax({
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: 'POST',
            url: `${calculatorEndpoint}/?handler=error`,
            data: error,
            dataType: 'json'
        });
    }
});

function errorHandler() {
    $('[data-motiv-form], [data-motiv-results], [data-motiv-footer], [data-motiv-quote-result]').hide();
    $('[data-motiv-calculator]').append('<div class="motivError"><p>We\'re really sorry, but something appears to have gone wrong. Our team have been notified and are working to resolve this issue, please try again later.</p></div>')
}

function scrollToTop() {
    $([document.documentElement, document.body]).animate({
        scrollTop: ($('[data-motiv-calculator]').offset().top - 24)
    }, 500);
}

function formSubmit(event) {
    if (event.originalEvent.submitter.hasAttribute('data-motiv-quote-submit')) {
        return resultSubmit(event, "quote", function (data) {
            $('[data-motiv-form]').addClass('d-none');
            $('[data-motiv-quote-result]').html(data).removeClass('d-none');
            scrollToTop();
        });
    }

    var form = $('[data-motiv-form]');

    if (!form.valid()) return;

    event.preventDefault();
    form.find('.motivForm__submit').addClass('motivForm__submit--loading').find('button').attr('disabled', true);

    $.ajax({
        url: `${calculatorEndpoint}/?handler=calculate`,
        method: 'POST',
        dataType: 'html',
        data: form.serialize(),
        success: function (data) {
            $('[data-motiv-calculator]').html(data);
            setupResults();
            localStorage.setItem('MotivCalculatorResultData', btoa(encodeURIComponent($('#MotivCalculator_CalculatorResponse_ResultData').val())));
            localStorage.setItem('MotivCalculatorFormData', btoa(encodeURIComponent($('#MotivCalculator_CalculatorDetails_FormData').val())));
            setupForm();
            scrollToTop();
        },
        error: function () {
            errorHandler();
        }
    });
}

function toggleResultInfo(event) {
    var control = $(event.currentTarget);
    var info = control.attr('data-motiv-result-info-control');
    $(`#${info}`).slideToggle();
}

function formReset() {
    $('[data-motiv-calculator]').removeAttr('data-motiv-submitted');
    $('[data-motiv-results]').addClass('d-none');
}

function closeQuoteForm() {
    $('[data-motiv-details], [data-motiv-results], [data-motiv-footer]').removeClass('d-none');
    $('[data-motiv-quote]').addClass('d-none');
    $('[data-motiv-calculator]').attr('data-motiv-submitted', '');
    $('[data-motiv-form]').toggleClass('d-none', requestLimitReached());
}

function requestLimitReached() {
    return $('#MotivCalculator_CalculatorResponse_RequestLimitReached').val() == 'True';
}

function loadQuoteForm(event) {
    event.preventDefault();
    $('[data-motiv-form]').removeClass('d-none');
    $('[data-motiv-details], [data-motiv-results], [data-motiv-footer]').addClass('d-none');
    $('[data-motiv-quote]').removeClass('d-none');
    $('#MotivCalculator_QuoteDetails_ProductId').val($(event.currentTarget).attr('data-motiv-quote-cta'));
    $('[data-motiv-calculator]').removeAttr('data-motiv-submitted');
    scrollToTop();
}

function submitEligibilityForm(event) {
    event.preventDefault();
    $('#MotivCalculator_QuoteDetails_ProductId').val($(event.currentTarget).attr('data-motiv-eligibility-cta'));
    return resultSubmit(event, "eligibility", function (data) {
        window.location.href = data;
    });
}

function resultSubmit(event, handler, success) {
    var form = $('[data-motiv-form]');

    if (!form.valid()) {
        return;
    }

    event.preventDefault();
    form.find('.motivForm__submit').addClass('motivForm__submit--loading').find('button').attr('disabled', true);

    $.ajax({
        url: `${calculatorEndpoint}/?handler=${handler}`,
        method: 'POST',
        dataType: 'html',
        data: form.serialize(),
        success: success,
        error: function () {
            errorHandler();
        }
    });
}

function updateGroups() {
    $('[data-motiv-group]').each(function () {
        var group = $(this);
        var control = $(`input[name="${group.attr('data-motiv-group')}"][aria-controls="${group.attr('data-motiv-group-value')}"]`);
        var controlVal = control.val();

        if (!controlVal) {
            return;
        }

        var selected = control.is(':checked');
        group.toggleClass('d-none', !selected);
    });
}

async function fetchDerivatives(term, token) {
    return new Promise((resolve, reject) => {
        $.ajax({
            method: 'GET',
            url: `${calculatorEndpoint}/?handler=Derivatives`,
            data: { search: term, nextToken: token },
            success(data) {
                resolve(data)
            },
            error(_xhr, _status, error) {
                reject(error)
            }
        });
    });
}

function setupMakeModel() {
    var makeModel = new autoComplete({
        selector: '#MotivCalculator_CalculatorDetails_MakeModel',
        placeHolder: 'Search for make and model...',
        threshold: 3,
        debounce: 300,
        searchEngine: 'loose',
        data: {
            src: async () => {
                var data = await fetchDerivatives(makeModel.input.value);
                return data.items;
            },
            keys: ['makeModelDerivative']
        },
        resultsList: {
            maxResults: undefined
        },
        resultItem: {
            element(item, data) {
                item.innerHTML = `
                    <p class="search__itemHeading">${data.match}</p>
                    <p class="search__itemDetails">${data.value.yearRange}</p>
                    <p class="search__itemDetails">${data.value.technicalDetails}</p>`;
            },
            highlight: true,
        },
        events: {
            input: {
                selection(event) {
                    const selection = event.detail.selection.value;

                    if (selection.nextToken) {
                        makeModel.nextToken = selection.nextToken;
                        makeModel.start();
                    }
                    else {
                        makeModel.input.value = selection.makeModelDerivative;
                        $('#MotivCalculator_CalculatorDetails_DerivativeId').val(selection.derivativeId).valid();
                        $('.autoComplete_wrapper').addClass('autoComplete_wrapper--selected');
                    }
                },
                focus() {
                    if (makeModel.input.value.length > 0) {
                        makeModel.open();
                    }
                }
            }
        }
    });
}

function loadStylesheet(tenant) {
    var stylesheet = $('<link>');
    stylesheet.attr('rel', 'stylesheet');
    stylesheet.attr('href', `${calculatorBaseUrl}/css/${tenant}.css`);
    $('head').append(stylesheet);
}

function resetDerivativeId() {
    $('#MotivCalculator_CalculatorDetails_DerivativeId').val('');
    $('.autoComplete_wrapper').removeClass('autoComplete_wrapper--selected');
}

function setupForm() {
    motivUi.setup
        .validation(':hidden:not("#MotivCalculator_CalculatorDetails_DerivativeId")')
        .inputFormatting()
        .visibleWhen();

    $.validator.unobtrusive.parse('[data-motiv-form]');
    $('[data-motiv-form]').on('keydown', function () { return event.key != 'Enter'; }).on('submit', formSubmit);
    $('[name="MotivCalculator.CalculatorDetails.FindVehicleMethod"]').on('change', resetDerivativeId);
    $('[data-motiv-reset]').on('click', formReset);
    $('[data-motiv-back]').on('click', closeQuoteForm);

    if ($('#MotivCalculator_CalculatorDetails_MakeModel').length) {
        setupMakeModel();
    }

    var privacyLabel = $('#MotivCalculator_QuoteDetails_PrivacyPolicyAgreement + label');
    var privacyPolicyUrl = $('#MotivCalculator_QuoteDetails_PrivacyPolicy').val();

    if (privacyLabel.length && privacyPolicyUrl) {
        privacyLabel.html(privacyLabel.html().replace('{0}', `<a href="${privacyPolicyUrl}">privacy policy</a>`));
    }
}

function setupResults() {
    $('[data-motiv-form]').find('.motivForm__submit').removeClass('motivForm__submit--loading').find('button').removeAttr('disabled');
    $('[data-motiv-calculator]').attr('data-motiv-submitted', '');
    $('[data-motiv-results]').removeClass('d-none');
    motivUi.onTrigger('change', '[data-motiv-group-control]', updateGroups);
    $('[data-motiv-quote-cta]').on('click', loadQuoteForm);
    $('[data-motiv-eligibility-cta]').on('click', submitEligibilityForm);
    $('[data-motiv-result-info-control]').on('click', toggleResultInfo);
}

$(async function () {
    var deviceFingerprint = await getDeviceFingerprint();
    var resultData = localStorage.getItem('MotivCalculatorResultData');
    var formData = localStorage.getItem('MotivCalculatorFormData');
    var headers = {
        deviceFingerprint: deviceFingerprint
    };

    if (resultData != null) {
        headers.resultData = resultData;
    }

    if (formData != null) {
        headers.formData = formData;
    }

    $.ajax({
        url: calculatorEndpoint,
        headers: headers
    }).done(function (data, status) {
        switch (status) {
            case 'success':
                $('[data-motiv-calculator]').html(data);
                setupForm();
                $('#MotivCalculator_CalculatorDetails_Dealership').val(dealership);
                $('#MotivCalculator_CalculatorDetails_Vrm').val(vrm);
                $('#MotivCalculator_CalculatorDetails_CurrentMileage').val(currentMileage);
                $('#MotivCalculator_CalculatorDetails_PurchasePrice').val(price);
                $('#MotivCalculator_CalculatorDetails_DeviceFingerprint').val(deviceFingerprint);
                if (requestLimitReached()) {
                    setupResults();
                    $('[data-motiv-form]').addClass('d-none');
                }
                break;
            default:
                errorHandler();
                break;
        }
    });
});
